/* Dynamic 3D Print Shop — small progressive-enhancement layer */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.d3d-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  // Re-run when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', reveal);
  document.addEventListener('shopify:block:select', reveal);
  // Safety: anything still hidden after 2.5s becomes visible (e.g. inside carousels)
  setTimeout(function () {
    document.querySelectorAll('.d3d-reveal:not(.is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.2) el.classList.add('is-visible');
    });
  }, 2500);
})();
